import React, { useLayoutEffect, useMemo, useState } from "react";
import cn from "classnames";
import { LABEL, CUSTOM_MESSAGES } from "../../../../veriables";
import ReceiptFooter from "../../../ReceiptFooter";
import PaidStamp from "@assets/images/payment/paid.png";
import styles from "@components/ServerAppPaymentScreens/serverAppPaymentScreens.module.scss";
import Modal from "@components/common/Modal";
import { urlSearchParams ,getObjectValue } from "../../../../utility/utills";
import { TouchableButton } from '@components/common/Touchable'
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import NotesIcon from '@assets/images/NotesIcon';
import { safeJsonParse, FormatLoyaltyPhoneNumber } from '@utility/helperFunction';
import { useSelector } from "react-redux";

const SplitChecks = ({
  tableData,
  currencySymbol,
  stageData,
  seatItems,
  onClickPaymentHandler,
  countryCode,
  allMenuItems,
  selectedStageIndex,
  sortedSeatItemHashTable,
  prevCheck,
  nextCheck,
  serverAppTheme,
  disablePayment,
  multiCheckSplitPaymentConfirm,
  seat,
  setSeat,
  setPaymentCheck,
  getSubTotalAmount,
  multiCheckSplitConfirm,
  setMultiCheckSplitConfirm
}) => {

  const previousSeatObj = JSON.parse(window.sessionStorage.getItem("seat"));
  const paymentCheckData = JSON.parse(window.sessionStorage.getItem("paymentCheck"));
  const ticketSplitTypeId = urlSearchParams('ticketSplitTypeId');
  const orderingPortraitOrientation =  useSelector(state=> state.orders.orderingPortraitOrientation);

  const popupStyles = useMemo(() => {
    const modal = {
      background: serverAppTheme ? serverAppTheme.popUp_bg : "#2F2F2F",
      border: serverAppTheme ? serverAppTheme.popupBorder : "1px solid #626262",
      borderRadius: "16px",
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: "486px",
    };
    const icon = {
      color: serverAppTheme ? serverAppTheme?.primary_text : "white",
    };
    const newcheck = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
    };
    const gotocheck = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
    };
    const cross = {
      top: '0.5rem',
      right: '0.5rem'
    }
    return { modal, icon, newcheck, gotocheck, cross };
  }, [serverAppTheme]);

  const renderModifier = (modifiersObj, nest) =>
    (modifiersObj || []).map((modifier) => (
      <>
        <div
          key={modifier.modifierId}
          className={cn(modifier?.price > 0 ? "fs_14 fw-500 row mx-0 col-12 p-0" : 'd-none')}
        >
          {modifier.quantity >= 1 ? (
            <div
              className={cn("col-2 text-center")}
              style={{ color: serverAppTheme?.primary_text }}
            >
              {" "}
              <div className={cn("va-tt fs_14")}>
                {modifier.quantity}
              </div>
            </div>
          ) : (
            <div className="p-0 text-left col-2 px-1"></div>
          )}
          <div
            className={cn("col-6 p-0 text-left fs_14")}
            style={{ color: serverAppTheme?.primary_text }}
          >
            {modifier.modifierName}
            {modifier.price ? (<span className={cn(
              'col-4 text-left fs_14 px-3'
            )}
              style={{

                color: serverAppTheme?.primary_text,
              }}>
              {LABEL().CURRENCY_SYMBOL}
              {modifier.price.toFixed(2)}
            </span>) : (<span
              className={cn(
                'col-4 text-left fs_14 px-3'
              )}
              style={{
                paddingRight: '0.7rem',

                color: serverAppTheme?.primary_text,
              }}
            >
              {' '}
              $0.00{' '}
            </span>)}
          </div>
          {(modifier.note || modifier.comment) && (
            <div className={cn('col-12 row mx-0 pr-0 fs-12 pl-64')}>
              <span className='col-1'>
                <NotesIcon />
              </span>
              <span className={cn('pl-0 col-11 pr-0 pl-2 fs-14')} style={{ color: "#000" }}>
                {modifier.note || modifier.comment}
              </span>
            </div>
          )}
        </div>
        <div>
          {modifier?.modifiers && modifier?.modifiers?.length > 0 && (
            <div>{renderModifier(modifier?.modifiers, true)}</div>
          )}
        </div>
      </>
    ));

  const excludeItemFromReceiptScreen = (item) => {
    let excludeProduct = false;
    allMenuItems?.forEach((insideItems) => {
      if (
        insideItems.id === item.menuItemId &&
        insideItems?.excludeFromReceipt
      ) {
        excludeProduct = true;
      }
    });
    return excludeProduct;
  };

  const getTipPercent = (tipAmount, tipPercent, tipCollected) => {
    const amount = (tipAmount / tipPercent) * 100;
    const actualPercentage = (tipCollected / amount) * 100;
    return (actualPercentage || 0)?.toFixed(2);
  };

  const onPaymentConfirm = (selectedStage) => {
    const paymentCheckData = seat?.paymentChecks.filter(
      (item, index) => {
        return index === selectedStageIndex
      }
    );
    setSeat({
      ...seat,
      stageData: selectedStage,
      totalAmount: selectedStage.totalAmount,
      paymentCheck: paymentCheckData[0],
    });
    setPaymentCheck({
      ...seat,
      ...selectedStage,
      subTotalAmount: getSubTotalAmount(selectedStage),
      paymentCheck: paymentCheckData[0],
    }).then(() => {
      setMultiCheckSplitConfirm(true);
    });
  };

  const seatCheckName = (item) => {
    let data = '';
    tableData?.items?.filter((el) => {
      if (el.id === item.id) {
        if (el?.seats?.length > 1) {
          if (el.seats[0]?.tableOrder) {
            data = "T"
            return
          } else {
            data = "S"
            return
          }
        } else {
          data = tableData?.seats?.filter((i) => i?.id === el?.seats[0]?.seatId)[0]?.number;
          return
        }
      }
    })
    return data;
  }

  const getLoyaltyOfferState = () => {
    const loyalty = seatItems?.loyalty ?? null;
    const offers = seatItems?.offers ?? null;

    if (loyalty && Array.isArray(offers) && offers.length > 0) {
      return 2; // both loyalty and offers
    } else if (loyalty) {
      return 1; // only loyalty
    } else {
      return 0; // neither
    }
  }

  // multi check presenter screen dynamic height
  const [dynamicHeight, setDynamicHeight] = useState({ itemList: "" });
const deviceinfo =  safeJsonParse(window.sessionStorage.getItem('auth'), {});
const footerlines = deviceinfo?.footerLines;
  const adjustHeight = () => {
    const totalInnerDiv = document.querySelectorAll("#innerDiv")?.length || 0;
    const state = getLoyaltyOfferState(); // 0, 1, or 2

    let baseHeight;

    if (totalInnerDiv === 2) {
      baseHeight = 69;
    } else if (totalInnerDiv === 3) {
      baseHeight = 65;
    } else if (totalInnerDiv === 4) {
      baseHeight =  61;
    } else if (totalInnerDiv === 5) {
      baseHeight = 57;
    } else if (totalInnerDiv === 6) {
      baseHeight = 53;
    } else if (totalInnerDiv === 7) {
      baseHeight = 49.4;
    } else if (totalInnerDiv === 8) {
      baseHeight = 45.5;
    } else if (totalInnerDiv === 9) {
      baseHeight = 41.5;
    } else {
      baseHeight = 38;
    }

    // Adjust further based on loyalty/offer state
    let adjustment = 0;

    if (state === 1) {
      adjustment = -6.2; // only loyalty
    } else if (state === 2) {
      adjustment = -12; // loyalty + offer
    }
     const getLineCount = (lines) =>
  lines?.reduce((total, line) => total + Math.ceil(line?.length / 65), 0); 
 const footerLineCount = footerlines && Array.isArray(footerlines) ? Math.min(getLineCount(footerlines), 5) : 0;

    // const footerLineCount = footerlines && Array.isArray(footerlines) ? Math.min(footerlines.length, 5) : 0;
    const footerAdjustment = footerLineCount > 0 ? -(footerLineCount * 2.5) : 0;

    const finalHeight = baseHeight + adjustment + footerAdjustment;

    setDynamicHeight({ itemList: finalHeight });
    return { itemList: finalHeight };
  }

  useLayoutEffect(() => {
    adjustHeight();
  }, [seatItems?.items]);

  const checkLoyalty = () => {
    const loyalty = seatItems?.loyalty ?? null
    return loyalty;
  };

  const checkOffer = () => {
    const offers = seatItems?.offers ?? null
    return offers;
  };

  return (
    <>
      <div className={cn("col-12 h-100 px-0")}>
        <div className="h-100">
          {/* qty items seat amount (static)*/}
          <div
            className={cn("col-12 h-4 fs_14 pb-1 row mx-0 w-100 align-items-center fw-500 pl-0")}
            style={{
              color: serverAppTheme?.itemQtyClr,
            }}
          >
            <div className={cn("p-0 col-2 text-center")}>
              {" "}
              <span> {LABEL().QTY}</span>
            </div>
            <div className={cn("px-0 text-left col-6")}>
              <div className="mx-0">{LABEL().ITEMS_LIST}</div>
            </div>
            <div className={cn("col-2 p-0 text-center")}>
              {" "}
              <span> Seat</span>
            </div>
            <div className={cn("col-2 pl-0 pr-0 text-right")}>
              <span>{LABEL().AMOUNT}</span>
            </div>
          </div>
          {/* qty items seat amount (dynamic)*/}
          {seatItems?.items?.length > 0 ? (
            <div
              className={cn(
                "overflowY",
              )}
              style={{
                height: `${dynamicHeight?.itemList}%`
              }}
            >
              {seatItems?.items?.map((item) => {
                const excludeFromReceipt = excludeItemFromReceiptScreen(item);
                return (
                  <>
                    {!excludeFromReceipt && (
                      <div
                        key={item.menuItemId}
                        className="col-12 row mx-0 mb-1 py-2 w-100 align-content-center fs_18 fw-400 pl-0 rounded"
                        style={{
                          color: serverAppTheme?.primary_text,
                          background: serverAppTheme?.tip_tile,
                        }}
                      >
                        {/* qty */}
                        <div className="p-0 col-2 text-center">
                          {item?.split > 1
                            ? `${item.quantity}/${item.split}`
                            : item.quantity}
                        </div>
                        {/* name */}
                        <div className="px-0 text-left col-6">
                          <div className="mx-0">
                            <span
                              className={cn("p-0")}
                            >
                              {`${item.menuItemName}`}
                            </span>
                          </div>
                        </div>
                        {/* seat */}
                        <div
                          className={cn(
                            "col-2 d-flex justify-content-center px-0 pr-0 align-items-center"
                          )}
                        >
                          <div
                            className={cn(
                              "fw-500 color-black roundedSm d-flex justify-content-center align-items-center"
                            )}
                            style={{
                              width: '1.8125rem',
                              height: "1.25rem",
                              background: serverAppTheme?.seat_bg,
                              color: serverAppTheme?.seat_box_text,
                            }}
                          >
                            {seatCheckName(item)}
                          </div>
                        </div>
                        {/* amount */}
                        <div className="col-2 pl-0 pr-0 text-right">
                          {currencySymbol}
                          {item?.price?.toFixed(2)}
                        </div>
                        {/* modifier */}
                        <div className="col-12 p-0">
                          {item.modifiers && renderModifier(item.modifiers)}
                          <div className="text-left pl-2 fs-18">
                            {`${item.note ? `- ${item.note}` : ""}`}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
              {previousSeatObj?.paymentChecks?.length > 0 &&
                previousSeatObj?.paymentChecks
                  ?.filter(
                    (checkId) =>
                      checkId?.checkSplitId === seatItems?.paymentStageId,
                  )
                  ?.map((item) => (
                    <>
                      {item?.discounts?.length > 0 &&
                        item?.discounts?.map((items) => (
                          <div
                            key={items.discountId}
                            className="col-12 row mx-0 mb-1 py-2 w-100 align-content-center fs_18 fw-400 pl-0 rounded"
                            style={{
                              color: serverAppTheme?.primary_text,
                              background: serverAppTheme?.tip_tile,
                            }}
                          >
                            {/* qty */}
                            <div className="p-0 col-2 text-center">
                              {items?.split}
                            </div>
                            {/* name */}
                            <div className="px-0 text-left col-6">
                              <div className="mx-0">
                                <span
                                  className={cn(
                                    "p-0"
                                  )}
                                >
                                  {items?.discountName}
                                </span>
                              </div>
                            </div>
                            {/* seat */}
                            <div className={cn("col-2 d-flex justify-content-center px-0 pr-0 align-items-center")}>
                              <div
                                className={cn(
                                  "fw-500 color-black roundedSm d-flex justify-content-center align-items-center"
                                )}
                                style={{
                                  width: '1.8125rem',
                                  height: "1.25rem",
                                  background: serverAppTheme?.seat_bg,
                                  color: serverAppTheme?.seat_box_text,
                                }}>
                                {ticketSplitTypeId == 3 ? 'S' : tableData?.discounts[0]?.seats?.length > 1 ? tableData?.discounts[0]?.seats[0]?.tableOrder ? 'T' : 'S' : seatItems?.seats[0]?.number}
                              </div>
                            </div>
                            {/* amount */}
                            <div className={cn("col-2 pl-0 pr-0 text-right")}>
                              -{currencySymbol}
                              {items?.value?.toFixed(2)}
                            </div>
                          </div>
                        ))}
                    </>
                  ))}
              {(seatItems?.paymentComplete || seatItems.splitStatus === 2) && (
                <div
                  className={cn(
                    "col-12 row justify-content-center position-fixed text-primary fs-30 fw-800",
                    styles.PaidStamp,
                  )}
                  style={{
                    top: "45%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  <img src={PaidStamp} alt="" height="100px" />
                </div>
              )}
            </div>
          ) : (
            <div
              className="d-flex fs-400 fs_20 justify-content-center align-items-center p-3"
              style={{
                height: `${dynamicHeight?.itemList}%`
              }}
            >
              {CUSTOM_MESSAGES().NO_ITEM_FOUND}
            </div>
          )}

          {/* LOYALTY && OFFERS */}
          {(["28", "31"].includes(urlSearchParams("screenType"))) && (
            <div
              className={cn(getLoyaltyOfferState() !== 0 && "my-1")}
              style={{
                height:
                  getLoyaltyOfferState() === 2
                    ? "90px"
                    : getLoyaltyOfferState() === 1
                      ? "50px"
                      : "0",
                overflowY: "auto"
              }}
            >
              {checkLoyalty() && (
                <div
                  id="loyaltyOfferDiv"
                  className={cn(
                    "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex pl-75 justify-content-between", styles.spanForPaymentt,
                  )}
                  style={{
                    background: serverAppTheme?.itemsBg,
                    borderRadius: "4px",
                    color: serverAppTheme?.primary_text
                  }}
                >
                  <div className="d-flex justify-content-start">
                    {LABEL().CHECK_PRESENTER_LOYALTY} {checkLoyalty().displayAccountNumber &&
                      <>
                        ({FormatLoyaltyPhoneNumber(checkLoyalty().displayAccountNumber)})
                      </>
                    }
                  </div>
                  <div className="d-flex justify-content-end"><SuccessIcon /></div>
                </div>
              )}
              {Array.isArray(checkOffer()) && checkOffer().length > 0 && checkOffer().map((offer, index) => (
                <div
                  id="loyaltyOfferDiv"
                  key={index}
                  className={cn(
                    "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex pl-75 justify-content-between",
                    styles.spanForPaymentt
                  )}
                  style={{
                    background: serverAppTheme?.itemsBg,
                    borderRadius: "4px",
                    color: serverAppTheme?.primary_text
                  }}
                >
                  <div className="d-flex justify-content-start">
                    {offer.name}
                  </div>
                  <div className="d-flex justify-content-end">
                    <SuccessIcon />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* total amount section */}
          <div
            className={cn(
              "col-12 rounded p-2 mt-1",
            )}
            style={{
              color: serverAppTheme?.primary_text,
              backgroundColor: serverAppTheme?.subTotalBg,
            }}
          >
            {countryCode !== "44" &&
              (seatItems?.discounts?.length > 0 ||
              seatItems?.offer !== null || paymentCheckData?.discounts?.length > 0) && (
                <div className="row m-0 fw-400 fs_20" id="innerDiv">
                  <div className="col-6 p-0 text-left">
                    {LABEL().RECEIPT_ITEMS}
                  </div>
                  <div className="col-6 p-0 fs_20 text-right">
                    {currencySymbol}
                    {seatItems.itemAmount.toFixed(2)}
                  </div>
                </div>
              )}
            {seatItems.discountAmount > 0 && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_DISCOUNT}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6"
                  )}
                >
                  -{currencySymbol}
                  {seatItems?.discountAmount?.toFixed(2)}
                </div>
              </div>
            )}
            {countryCode !== "44" && seatItems?.offer > 0 && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_OFFER_KEY}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6"
                  )}
                >
                  -{currencySymbol}
                  {seatItems?.offer?.toFixed(2)}
                </div>
              </div>
            )}

            {countryCode !== "44" && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_SUBTOTAL}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6"
                  )}
                >
                  {currencySymbol}
                  {(seatItems?.subTotalAmount || seatItems?.subTotalAmount === 0) &&
                    seatItems?.subTotalAmount?.toFixed(2)}
                </div>
              </div>
            )}
            {countryCode !== "44" && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_TAX}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6"
                  )}
                >
                  {currencySymbol}
                  {(seatItems?.taxAmount || seatItems?.taxAmount === 0) &&
                    seatItems?.taxAmount?.toFixed(2)}
                </div>
              </div>
            )}
            {seatItems?.serviceChargeAmount > 0 && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_SERVICE_CHARGE}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6"
                  )}
                >
                  {currencySymbol}
                  {seatItems?.serviceChargeAmount?.toFixed(2)}
                </div>
              </div>
            )}
            {seatItems.totalAmount > 0 && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_TOTAL}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6"
                  )}
                >
                  {currencySymbol}
                  {seatItems?.totalAmount?.toFixed(2)}
                </div>
              </div>
            )}
            {countryCode === "44" && seatItems.taxAmount > 0 && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_TAX}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6"
                  )}
                >
                  {currencySymbol}
                  {(seatItems?.taxAmount || seatItems?.taxAmount === 0) &&
                    seatItems?.taxAmount?.toFixed(2)}
                </div>
              </div>
            )}
            {seatItems.paidAmount > 0 && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_PAID}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6"
                  )}
                >
                  {currencySymbol}
                  {(seatItems?.paidAmount || seatItems?.paidAmount === 0) &&
                    seatItems?.paidAmount?.toFixed(2)}
                </div>
              </div>
            )}
            {countryCode !== "44" && seatItems?.giftCardKey && (
              <div
                className="row m-0 fw-400 fs_20"
                id="innerDiv"
              >
                <div className={cn("col-6 p-0 text-left")}>
                  {LABEL().RECEIPT_GIFT_CARD}
                </div>
              </div>
            )}
            {countryCode !== "44" &&
              (seatItems.unpaidAmount === 0 || seatItems?.paidAmount > 0) &&
              seatItems?.items?.length > 0 && (
                <div
                  className="row m-0 fw-400 fs_20"
                  id="innerDiv"
                >
                  <div
                    className={cn("col-6 p-0 text-left")}
                  >
                    {LABEL().RECEIPT_TIP}{" "}
                    {`(${getTipPercent(seatItems?.tip?.tipAmount, seatItems?.tip?.tipTypeValue, seatItems?.tipCollectedAmount) || 0}%)`}
                  </div>
                  <div
                    className={cn(
                      "p-0 text-right col-6"
                    )}
                  >
                    {currencySymbol}
                    {(seatItems?.tipCollectedAmount || 0)?.toFixed(2)}
                  </div>
                </div>
              )}
            {countryCode !== "44" &&
              (seatItems?.unpaidAmount === 0 || seatItems?.paidAmount > 0) &&
              seatItems?.items?.length > 0 && (
                <div
                  className="row m-0 fw-400 fs_20"
                  id="innerDiv"
                >
                  <div
                    className={cn("col-6 p-0 text-left")}
                  >
                    {LABEL().RECEIPT_TOTAL_PAID}
                  </div>
                  <div
                    className={cn(
                      "p-0 text-right col-6"
                    )}
                  >
                    {currencySymbol}
                    {(
                      Number(seatItems?.paidAmount) +
                      Number(seatItems?.tipCollectedAmount || 0)
                    )?.toFixed(2)}
                  </div>
                </div>
              )}
            {countryCode !== "44" && seatItems?.unpaidAmount !== 0 && (
              <div
                className="row m-0 fw-600 fs_20"
                id="innerDiv"
              >
                <div
                  className={cn("col-6 p-0 text-left")}
                >
                  {LABEL().RECEIPT_DUE}
                </div>
                <div
                  className={cn(
                    "p-0 text-right col-6",
                  )}
                >
                  {currencySymbol}
                  {(seatItems?.unpaidAmount || seatItems?.unpaidAmount === 0) &&
                    seatItems?.unpaidAmount.toFixed(2)}
                </div>
              </div>
            )}
          </div>
      <ReceiptFooter/>
          {/* prev next pay buttons */}
          <div
            className={cn('col-12 px-0 position-absolute',orderingPortraitOrientation ? styles.btnposition : '')}
          >
            <div className="col-12 px-0 py-2 row justify-content-center mx-0 align-items-center">
              <TouchableButton
                disabled={selectedStageIndex === 0}
                type="button"
                className={cn(
                  "col-5 p-1 btn-ripple text-center h-7",
                  styles.checkPresenterBtn,
                  selectedStageIndex === 0
                    ? "od-disable-btn-bg-color od-disable-btn-font-color"
                    : "od-primary-btn-bg-color od-primary-btn-font-color"
                )}
                style={{
                  lineHeight: "normal",
                  border: "none",
                  fontSize: "1.5rem",
                  fontWeight: '600',
                  backgroundColor: selectedStageIndex === 0 ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.secondaryBtn,
                  color : selectedStageIndex === 0 ? '#636363' : serverAppTheme?.btn_font_color,
                  height: '56px'
                }}
                onClick={(event) => {
                  event.preventDefault();
                  prevCheck();
                }}
                rippleEffect={true}
              >
                {LABEL().CHECK_PRESENTER_PREVIOUS_CHECK}
              </TouchableButton>
              <div
                className={cn(
                  "col-2 px-0 text-center fs_22 fw-600"
                )}
              >
                {" "}
                {selectedStageIndex +
                  1 +
                  " of " +
                  tableData?.paymentChecks?.length}
              </div>
              <TouchableButton
                disabled={selectedStageIndex >= sortedSeatItemHashTable?.length - 1}
                type="button"
                className={cn(
                  "col-5 p-1 btn-ripple text-center h-7",
                  styles.checkPresenterBtn,
                  selectedStageIndex < sortedSeatItemHashTable?.length - 1
                    ? "od-primary-btn-bg-color od-primary-btn-font-color"
                    : "od-disable-btn-bg-color od-disable-btn-font-color"
                )}
                style={{
                  lineHeight: "normal",
                  border: "none",
                  fontSize: "1.5rem",
                  wordSpacing: "99999px",
                  fontWeight: '600',
                  backgroundColor: selectedStageIndex < sortedSeatItemHashTable?.length - 1 ? serverAppTheme?.secondaryBtn : serverAppTheme?.secondaryBtnDisabled ,
                  color : selectedStageIndex < sortedSeatItemHashTable?.length - 1  ? serverAppTheme?.btn_font_color :'#636363',
                  height: '56px'
                }}
                onClick={(event) => {
                  event.preventDefault();
                  nextCheck();
                }}
                rippleEffect={true}
              >
                {LABEL().CHECK_PRESENTER_NEXT_CHECK}
              </TouchableButton>

            </div>
            {(!seatItems.paymentComplete && seatItems.splitStatus !== 2) && (
              <TouchableButton
                type="button"
                onClick={(event) => {
                  event.preventDefault();
                  disablePayment
                    ? onPaymentConfirm(seatItems)
                    : onClickPaymentHandler(seatItems);
                }}
                disabled={Number(seatItems.unpaidAmount) === 0}
                className={cn(
                  "align-items-center col-12 d-flex justify-content-center fs_28 h-7",
                  styles.payButton,
                  styles.checkPresenterBtn,
                  (stageData?.status !== 0 || Number(seatItems?.unpaidAmount) === 0)
                    ? "od-disable-btn-bg-color od-disable-btn-font-color"
                    : "od-primary-btn-bg-color od-primary-btn-font-color"
                )}
                style={{
                  background:
                    stageData?.status !== 0 || Number(seatItems?.unpaidAmount) === 0
                      ? "#B1B1B1"
                      : serverAppTheme?.secondaryBtn,
                  color: stageData?.status !== 0 || Number(seatItems?.unpaidAmount) === 0 ? serverAppTheme?.btn_font_color_disabled : "#fff",
                  height: '56px'
                }}
                rippleEffect={true}
              >
                {disablePayment ? LABEL().CHECK_PRESENTER_PAID : LABEL().CHECK_PRESENTER_PAY} {currencySymbol}
                {seatItems?.unpaidAmount?.toFixed(2)}
              </TouchableButton>
            )}

            {(seatItems.paymentComplete || seatItems.splitStatus === 2) && (
              <div
                className={cn(
                  "d-flex justify-content-center",
                )}
              >
                <img src={PaidStamp} alt="" height="60px" width="100px" />
              </div>
            )}
          </div>

        </div>
      </div>

      {/* MCP Split Modal */}
      {multiCheckSplitConfirm &&
        <Modal
          isOpen={multiCheckSplitConfirm}
          isModalCenter
          noBackground
          customClass2="h-100 w-100 p-3 d-flex justify-content-center align-items-center my-0"
          customClass="h-100 w-100"
          style={popupStyles.modal}
        >
          <div
            className="col-12 px-0 pb-2 pt-3 justify-content-center align-items-center position-relative text-center"
            style={popupStyles.icon}
          >
            <div className="row px-0 mx-0 pb-3">
              <div className="col-12 px-0 fs_18 fw-700 text-center d-flex align-items-center justify-content-center">
                Are You Sure ?
              </div>
            </div>
            <div className="col-12 fs_18 fw-400 text-center pb-2">
              {CUSTOM_MESSAGES().SPLIT_CONFIRM}
            </div>
            <div className="col-12 w-100 row mx-0 py-2 px-0 justify-content-center align-items-center text-center p-3">
              <div className="col-6 pl-0 pr-1">
                <button
                  className={cn(styles.Unselected_menu_btn, "w-100 btn44 rounded")}
                  style={popupStyles.newcheck}
                  type="button"
                  onClick={() => setMultiCheckSplitConfirm(false)}
                >
                  <div className="fs_24 fw-600">{LABEL().NO}</div>
                </button>
              </div>
              <div className="col-6 pr-0 pl-1">
                <button
                  className={cn(
                    styles.secondary_btn_color,
                    "w-100 btn44 border-0 rounded",
                  )}
                  style={popupStyles.gotocheck}
                  type="button"
                  onClick={() => multiCheckSplitPaymentConfirm()}
                >
                  <div className="fs_24 fw-600">{LABEL().YES}</div>
                </button>
              </div>
            </div>
          </div>
        </Modal>
      }
    </>
  );
};

export default SplitChecks;
